module.exports = __webpack_public_path__ + "img/cy.0aa2c719.svg";